// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__VdAE5","rowHeader":"styles_rowHeader__Tqpp8","cell":"styles_cell__eVTlB","cellHeader":"styles_cellHeader__so8Qh","cellBody":"styles_cellBody__jAu57"};